module.exports = __webpack_public_path__ + "media/images/lb/990-b3437093817e2986b308dd11fd990f73.svg";